<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4 mb-5">
    <div style="max-width:640px">
      <h3 class="mb-1">SMTP Config</h3>
      <div style="font-style: italic; color:var(--bo-muted)">
        Utgående e-post (velkomst-, varsel-, frakt-etikett-e-poster m.m.). Lagres i Couchbase (ikke i
        kildekode/git); passordet lagres <strong>kryptert</strong>. Endringer tas i bruk uten restart.
      </div>

      <div class="alert alert-info mt-3 py-2" style="font-size:0.88rem">
        <font-awesome-icon :icon="['fas', 'lock']" />
        Passordet vises aldri her igjen etter lagring. La feltet stå <strong>tomt</strong> for å beholde
        eksisterende — fyll det kun ut for å erstatte.
      </div>

      <config-lock ref="lock" :configured="isConfigured">
      <div class="row g-3 mt-1">
        <div class="col-md-8">
          <label class="form-label mb-1 smtp-label">Host</label>
          <input class="form-control" type="text" v-model="form.host" placeholder="smtp.zoho.com" />
        </div>
        <div class="col-md-4">
          <label class="form-label mb-1 smtp-label">Port</label>
          <input class="form-control" type="text" v-model="form.port" placeholder="587" />
        </div>
        <div class="col-md-6">
          <label class="form-label mb-1 smtp-label">Bruker (from-adresse)</label>
          <input class="form-control" type="text" v-model="form.user" placeholder="support@cagista.com" autocomplete="off" />
        </div>
        <div class="col-md-6">
          <label class="form-label mb-1 smtp-label">Passord</label>
          <div class="mb-1">
            <span class="badge" :class="config.passwordSet ? 'bg-success' : 'bg-secondary'">
              {{ config.passwordSet ? 'Konfigurert ✓' : 'Ikke satt — e-post feiler' }}
            </span>
          </div>
          <div style="position:relative">
            <input :type="showPassword ? 'text' : 'password'" class="form-control" style="padding-right:38px"
                   v-model="form.password" autocomplete="new-password"
                   :placeholder="config.passwordSet ? '•••• (lagret — la stå tomt)' : 'Lim inn SMTP-passord'" />
            <button type="button" @click="showPassword = !showPassword" :title="showPassword ? 'Skjul' : 'Vis'"
                    style="position:absolute; right:10px; top:50%; transform:translateY(-50%); border:none; background:none; color:var(--bo-muted); cursor:pointer; padding:0; line-height:1;">
              <font-awesome-icon :icon="['fas', showPassword ? 'eye-slash' : 'eye']" />
            </button>
          </div>
        </div>
      </div>

      <div class="mt-4 d-flex align-items-center gap-3">
        <button class="bo_btn" @click="save" :disabled="saving">{{ saving ? 'Lagrer…' : 'Lagre' }}</button>
        <span v-if="message" :class="error ? 'text-danger' : 'text-success'">{{ message }}</span>
      </div>
      </config-lock>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ConfigLock from "@/components/other/ConfigLock";
import SettingsService from "@/services/settings/SettingsService";

export default {
  name: "SmtpConfig",
  components: { LoadingSpinner, ConfigLock },
  computed: {
    // Already configured (→ starts locked): the SMTP password is already stored server-side.
    isConfigured() { return !!this.config.passwordSet; }
  },
  data() {
    return {
      loading: true,
      config: {},
      form: { host: "", port: "", user: "", password: "" },
      showPassword: false,
      saving: false,
      message: "",
      error: false
    };
  },
  mounted() {
    this.loadConfig();
  },
  methods: {
    loadConfig() {
      SettingsService.getSmtpConfig().then(
        (response) => {
          this.config = response.data || {};
          this.form.host = this.config.host || "";
          this.form.port = this.config.port || "";
          this.form.user = this.config.user || "";
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke hente konfigurasjon.");
        }
      );
    },
    save() {
      this.saving = true;
      this.message = "";
      this.error = false;
      SettingsService.saveSmtpConfig({
        host: this.form.host, port: this.form.port, user: this.form.user, password: this.form.password
      }).then(
        (response) => {
          this.saving = false;
          this.config = response.data || {};
          this.form.password = "";
          this.showPassword = false;
          this.error = false;
          this.message = "Lagret ✓ — tas i bruk umiddelbart (ingen restart).";
          this.$refs.lock.relock();   // re-lock after a successful save
        },
        (error) => {
          this.saving = false;
          this.error = true;
          this.message = this.errMsg(error, "Kunne ikke lagre konfigurasjon.");
        }
      );
    },
    errMsg(error, fallback) {
      const data = error && error.response ? error.response.data : null;
      return (data && data.error) || fallback;
    }
  }
};
</script>

<style scoped>
.smtp-label {
  font-size: 0.85rem;
  color: var(--bo-muted);
}
</style>
